module.exports = __webpack_public_path__ + "img/down12.16796033.png";